import CodeLibrary from "../CodeLibrary/CodeLibrary"
import Header from "../Header/Header";

function CodeSection() {

  return (
    <>
      <Header />
      <CodeLibrary></CodeLibrary>
    </>
  );
}

export default CodeSection;
